/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerLocationCities.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Location Cities
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, July 07, 2019 - 04:35:28 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      07/07/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    LOCATIONCITY_LIST_CONTAINER_LOADED,
    LOCATIONCITY_LIST_CONTAINER_UNLOADED,
    LOCATIONCITY_LIST_TABLE_LOADED,
    LOCATIONCITY_LIST_TABLE_UNLOADED,

    LOCATIONCITY_LIST_CHANGE_GROUP,

    LOCATIONCITY_SELECT_ROW,
    LOCATIONCITY_ADD,
    LOCATIONCITY_EDIT,
    LOCATIONCITY_DELETE,
    LOCATIONCITY_OPEN_WARNING,
    LOCATIONCITY_CLOSE_WARNING,
    LOCATIONCITY_DELETE_DISABLE,

    LOCATIONCITY_EDIT_CONTAINER_LOADED,
    LOCATIONCITY_EDIT_CONTAINER_UNLOADED,
    LOCATIONCITY_EDIT_FORM_LOADED,
    LOCATIONCITY_EDIT_FORM_UNLOADED,
    LOCATIONCITY_EDIT_DATA_LOAD,
    LOCATIONCITY_EDIT_CONTAINER_SUBMIT,
    LOCATIONCITY_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeLocationCities';

const defaultState = {
    refreshList: false,
    danger: false,
    locationcityid: 0,
    countryid: 0,
    stateid: 0,
    name: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case LOCATIONCITY_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                locationcities: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null,
                states: action.payload[2] ? action.payload[2].records : null,
            }
        case LOCATIONCITY_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case LOCATIONCITY_LIST_CHANGE_GROUP:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case LOCATIONCITY_SELECT_ROW:
            return {
                ...state,
                locationcityid: action.id
            }
        case LOCATIONCITY_ADD:
            return {
                ...state
            }
        case LOCATIONCITY_EDIT:
            return {
                ...state,
                locationcityid: action.id
            }
        case LOCATIONCITY_DELETE:
            return {
                ...state,
                locationcityid: null
            }
        case LOCATIONCITY_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case LOCATIONCITY_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case LOCATIONCITY_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case LOCATIONCITY_EDIT_CONTAINER_LOADED:
        case LOCATIONCITY_EDIT_DATA_LOAD:
            return {
                ...state,
                locationcityid: action.payload[0] ? action.payload[0].locationcityid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[2] ? action.payload[2].name : action.payload[0] ? action.payload[0].state : '',
                name: action.payload[0] ? action.payload[0].name : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case LOCATIONCITY_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case LOCATIONCITY_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case LOCATIONCITY_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case LOCATIONCITY_LIST_CONTAINER_UNLOADED:
        case LOCATIONCITY_LIST_TABLE_UNLOADED:
        case LOCATIONCITY_EDIT_CONTAINER_UNLOADED:
        case LOCATIONCITY_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerLocationCities.js